/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CheckEligibilityResponse } from './CheckEligibilityResponse';
import {
    CheckEligibilityResponseFromJSON,
    CheckEligibilityResponseFromJSONTyped,
    CheckEligibilityResponseToJSON,
    CheckEligibilityResponseToJSONTyped,
} from './CheckEligibilityResponse';

/**
 * 
 * @export
 * @interface CheckEligibility200Response
 */
export interface CheckEligibility200Response {
    /**
     * 
     */
    data?: CheckEligibilityResponse;
}

/**
 * Check if a given object implements the CheckEligibility200Response interface.
 */
export function instanceOfCheckEligibility200Response(value: object): value is CheckEligibility200Response {
    return true;
}

export function CheckEligibility200ResponseFromJSON(json: any): CheckEligibility200Response {
    return CheckEligibility200ResponseFromJSONTyped(json, false);
}

export function CheckEligibility200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckEligibility200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : CheckEligibilityResponseFromJSON(json['data']),
    };
}

export function CheckEligibility200ResponseToJSON(json: any): CheckEligibility200Response {
    return CheckEligibility200ResponseToJSONTyped(json, false);
}

export function CheckEligibility200ResponseToJSONTyped(value?: CheckEligibility200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CheckEligibilityResponseToJSON(value['data']),
    };
}

